import { useState } from 'react';
import { FilePlus, Files, Contact } from 'lucide-react';
import CreateBill from './bills/CreateBill';
import BillsList from './bills/BillsList';
import BillContacts from './bills/BillContacts';

const TABS = [
  { id: 'create', label: 'Create', icon: FilePlus },
  { id: 'bills', label: 'Bills', icon: Files },
  { id: 'contacts', label: 'Contacts', icon: Contact },
];

export default function Bills() {
  const [activeTab, setActiveTab] = useState('create');

  const renderContent = () => {
    switch (activeTab) {
      case 'create':
        return <CreateBill onCreated={() => setActiveTab('bills')} />;
      case 'bills':
        return <BillsList />;
      case 'contacts':
        return <BillContacts />;
      default:
        return null;
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-4xl md:text-5xl font-bold font-heading text-white tracking-tight" data-testid="bills-title">
          Bills
        </h1>
        <p className="text-base text-muted-foreground mt-2">Create and manage client invoices</p>
      </div>

      <div className="border-b border-zinc-800">
        <nav className="flex gap-1 -mb-px overflow-x-auto" data-testid="bills-tabs">
          {TABS.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                data-testid={`bills-tab-${tab.id}`}
                className={`flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
                  isActive
                    ? 'border-white text-white'
                    : 'border-transparent text-zinc-500 hover:text-zinc-300'
                }`}
              >
                <Icon className="w-4 h-4" strokeWidth={1.5} />
                {tab.label}
              </button>
            );
          })}
        </nav>
      </div>

      {renderContent()}
    </div>
  );
}
